// extracted by mini-css-extract-plugin
module.exports = {"textMargin":"TooltipError_textMargin__E_v7v"};